import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable} from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import {
    WeightMeterActionTypes,
    WeightMeterAdd,
    WeightMeterAdded,
    WeightMeterAllLoaded,
    WeightMeterDelete,
    WeightMeterDeleted,
    WeightMeterEdit,
    WeightMeterEdited,
    WeightMeterGetAll,
    WeightMeterGetPage,
    WeightMeterPageLoaded,
} from '../_actions/weight-meter.actions';
import { WeightMeterService } from '../_services/weight-meter.service';


@Injectable()
export class WeightMeterEffects {

    constructor(
        private actions: Actions,
        private weightMeterService: WeightMeterService,
        private router: Router,
    ) {}

    @Effect()
    add: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_ADD),
        map((action: WeightMeterAdd) => action.payload),
        switchMap(payload => {
            return this.weightMeterService.add(payload.weightMeter).pipe(
                map((weightMeterId)=>{ //Adecuarse a la response recibida de api real
                    //console.log("add weightMeter");
                    //console.log(JSON.stringify(payload.weightMeter));
                    let weightMeter = {
                        ...payload.weightMeter,
                        id: weightMeterId
                    };
                    return new WeightMeterAdded({weightMeter: weightMeter});
                })
            );
        })  
    );

    @Effect()
    edit: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_EDIT),
        map((action: WeightMeterEdit) => action.payload),
        switchMap(payload => {
            console.log("payload edit weightmeter: " +JSON.stringify(payload));
            return this.weightMeterService.edit(payload.weightMeter).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("edit weightMeter");
                    //console.log(JSON.stringify(payload.weightMeter));
                    return new WeightMeterEdited({partialWeightMeter: payload.weightMeter, weightMeter:payload.weightMeter});
                })
            );
        })  
    );

    @Effect()
    delete: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_DELETE),
        map((action: WeightMeterDelete) => action.payload),
        switchMap(payload => {
            return this.weightMeterService.delete(payload.weightMeter).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("delete weightMeter");
                    //console.log(JSON.stringify(payload.weightMeter));
                    return new WeightMeterDeleted({id: payload.weightMeter.id});
                })
            );
        })  
    );

    @Effect()
    getPage: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_GET_PAGE),
        map((action: WeightMeterGetPage) => action.payload),
        switchMap(payload => {
            return this.weightMeterService.getPage(payload.page).pipe(
                map((response)=>{ //Adecuarse a la response recibida de api real
                    //console.log("get page weightMeter");
                    //console.log(JSON.stringify(payload.weightMeter));
                    return {weightMeters: response.items, page: payload.page, totalCount: response.totalCount};
                })
            );
        }),
        map((response)=>{
            return new WeightMeterPageLoaded(response);
        })
    );

    @Effect()
    getAll: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_GET_ALL),
        map((action: WeightMeterGetAll) => action.payload),
        switchMap(payload => {            
            return this.weightMeterService.getAll().pipe(
                map((weightMeters)=>{ //Adecuarse a la response recibida de api real
                    //console.log("get all weightMeters");
                    //console.log(JSON.stringify(weightMeters));
                    return weightMeters
                })
            );
        }),
        map((weightMeters)=>{
            return new WeightMeterAllLoaded({weightMeters: weightMeters});
        })
    );

    @Effect({dispatch:false})
    pageLoaded: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_PAGE_LOADED),
        //tap((action:WeightMeterPageLoaded)=>console.log("weightMeter page loaded"))
    );

    @Effect({dispatch:false})
    allLoaded: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_ALL_LOADED),
        //tap((action:WeightMeterAllLoaded)=>console.log("weightMeter all loaded"))
    );

    @Effect({dispatch:false})
    added: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_ADDED),
        //tap((action:WeightMeterAdded)=>console.log("weightMeter added"))
    );

    @Effect({dispatch:false})
    edited: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_EDITED),
        //tap((action:WeightMeterEdited)=>console.log("weightMeter edited"))
    );

    @Effect({dispatch:false})
    deleted: Observable<any> = this.actions.pipe(
        ofType(WeightMeterActionTypes.WEIGHT_METER_DELETED),
        //tap((action:WeightMeterDeleted)=>console.log("weightMeter deleted"))
    );
}